<template>
    <b-container class="mt-5" v-if="eventId">
        <b-row>
            <b-col>
                <b-card :header="event.name">
                    <p class="lead">
                        <strong>{{ event.organizer }}</strong> invited you to join <strong>{{ event.name }}</strong>!
                    </p>
                    <p>
                        <strong>When?</strong> {{ this.event.datetime.fromNow() }}
                    </p>
                    <p>
                        <strong>Where?</strong> {{ this.event.eventAddress }}
                    </p>
                    <GmapMap ref="mapping" :center="markers['Event'].position" :zoom="16" map-type-id="terrain" style="width: 100%; height: 300px">
                      <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :label="index"/>
                    </GmapMap>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-card header="RSVP" class="mt-2">
                    <b-form @submit.prevent="onAnswer">
                        <b-form-group id="name-label" label="Name:" label-for="name">
                            <b-form-input id="name" v-model="participant.name" type="text" required placeholder="Enter name"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Are you going?">
                            <b-form-radio-group id="going-group" v-model="participant.going" :options="['yes', 'no']" name="going" buttons button-variant="outline-primary" ></b-form-radio-group>
                        </b-form-group>
                        <b-button type="submit" variant="primary">Answer</b-button>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="event.allowMovieSuggestions && participant.going == 'yes'">
            <b-col>
                <b-card header="Add Movies" class="mt-2">
                    <b-row>
                        <b-col>
                            <b-form class="mb-2">
                                <b-form-input v-model="movie" @keyup="onMovie" class="mt-3" placeholder="Search for movie"></b-form-input>
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row li v-for="(movie, index) in movies" :key="index" class="mb-2">
                        <b-col cols="12" md="2">
                            <b-img thumbnail fluid :src="movie.cover" />
                        </b-col>
                        <b-col cols="12" md="10">
                            <p class="float-right"><small>{{ movie.tmdbVoteAverage }}/10 ({{ movie.tmdbVoteCount }} votes)</small></p>
                            <h2>{{ movie.title }} </h2>
                            <p>{{ movie.description }}</p>
                            <div class="text-right">
                                <b-button size="sm" variant="primary" @click="addMovie(movie)">Add</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col>
                <b-card header="Already suggested movies" class="mt-2">
                    <b-row li v-for="(movie, index) in sortedEventMovies" :key="index" class="mt-2">
                        <b-col cols="12" md="2">
                            <b-img thumbnail fluid :src="movie.cover" />
                        </b-col>
                        <b-col cols="12" md="10">
                            <h2 class="mb-0">{{ movie.title }}</h2>
                            <p class="mt-0 mb-0"><small>TMDB: {{ movie.tmdbVoteAverage }}/10 ({{ movie.tmdbVoteCount }} votes) / Event: {{ movie.votes.length }}</small></p>
                            <p>{{ movie.description }}</p>
                            <div class="text-right mb-2">
                                <b-button size="sm" variant="danger" @click="demoteMovie(movie)">Demote</b-button>&nbsp;
                                <b-button size="sm" variant="primary" @click="voteMovie(movie)">Vote</b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import {gmapApi} from 'vue2-google-maps'
import axios from 'axios'

export default {
    computed: {
        google: gmapApi,
        sortedEventMovies() {
            return this.eventMovies.sort((m1, m2) => {
                return m1.title < m2.title ? -1 : 1
            })
        }
    },
    data() {
        return {
            eventRef: null,
            movieRef: null,
            participantRef: null,
            event: {
                allowMovieSuggestions: false,
                datetime: '',
                eventLocation: {
                    position: { lat: 0, lng: 0}
                },
                movies: [],
                name: '',
                organizer: '',
                organizerId: '',
                parkingLocation: {
                    position: { lat: 0, lng: 0}
                },
                publicTransportLocation: {
                    position: { lat: 0, lng: 0}
                }
            },
            eventId: '',
            eventMovies: [],
            movie: '',
            movies: [],
            participant: {
                name: '',
                going: false
            },
            markers: {
                'Event': {
                    position: { lat: 0, lng: 0}
                },
                'Parking': {
                    position: { lat: 0, lng: 0}
                },
                'Public Transport': {
                    position: { lat: 0, lng: 0}
                }
            },
            currentMarker: 'Event',
            getMap:this.$refs.mapping,
            description: '',
            latLng: {},
            place: null,
            timer: null
        }
    },
    mounted() {
        firebase.auth().onAuthStateChanged(user => {
            if (user && user.displayName) {
                this.participant.name = user.displayName
            }
        })
        const eventId = this.$route.params.eventId
        this.eventRef = firebase.firestore().doc(`/events/${eventId}`)
        this.movieRef = this.eventRef.collection('movies')
        this.participantRef = this.eventRef.collection('participants')
        this.movieRef.onSnapshot(ds => {
            this.eventMovies = ds.docs.map((m) => m.data())
        })
        this.eventRef.get().then(doc => {
            this.eventId = doc.id
            this.event = doc.data()
            this.event.datetime = moment(this.event.datetime)
            this.markers = {
                'Event': {
                    position: {
                        lat: this.event.eventLocation.latitude,
                        lng: this.event.eventLocation.longitude,
                    }
                },
                'Parking': {
                    position: {
                        lat: this.event.parkingLocation.latitude,
                        lng: this.event.parkingLocation.longitude,
                    }
                },
                'Public Transport': {
                    position: {
                        lat: this.event.publicTransportLocation.latitude,
                        lng: this.event.publicTransportLocation.longitude,
                    }
                }
            }
        })
        this.movieRef.get().then(res => {
            this.eventMovies = res.docs.map((m) => m.data())
        })
        this.participantRef.get().then(res => {
            res.docs.forEach(d => {
                if (d.id == firebase.auth().currentUser.uid) this.participant.going = 'yes'
            })
        })

    },
    methods: {
        async onAnswer() {
            if (!firebase.auth().currentUser) {
                await firebase.auth().signInAnonymously()
            }
            const userId = firebase.auth().currentUser.uid
            this.eventRef.collection('participants').doc(userId).set({
                name: this.participant.name,
                going: this.participant.going
            })
        },
        async onMovie() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                if (this.movie == '') {
                    this.movies = []
                    return
                }
                axios.get('https://api.themoviedb.org/3/search/movie', {
                    params: {
                        query: this.movie,
                        api_key: '59fe4a76def3a44749f8e89e56d1ec15'
                    }
                }).then(res => {
                    this.movies = []
                    const movieRef = this.eventRef.collection('movies')
                    res.data.results.forEach(movie => {
                        if (this.eventMovies.filter(em => em.id == movie.id).length) return
                        this.movies.push({
                            id: movie.id,
                            title: movie.title,
                            description: movie.overview,
                            tmdbVoteAverage: movie.vote_average,
                            tmdbVoteCount: movie.vote_count,
                            cover: 'https://image.tmdb.org/t/p/w200' + movie.poster_path,
                            bring: '',
                            votes: [],
                        })
                    })
                })
            }, 800);
        },
        async addMovie(movie) {
            await this.movieRef.doc(movie.id.toString()).set(movie).then(() => this.voteMovie(movie))
            this.movie = ''
        },
        async voteMovie(movie) {
            const el = await this.movieRef.doc(movie.id.toString())
            let votes = []
            await el.get().then(doc => votes = doc.data().votes)
            votes.push(firebase.auth().currentUser.uid)
            votes = Array.from(new Set(votes))
            el.update({votes})
        },
        async demoteMovie(movie) {
            const el = await this.movieRef.doc(movie.id.toString())
            let votes = []
            await el.get().then(doc => votes = doc.data().votes)
            votes = votes.filter(uid => uid !== firebase.auth().currentUser.uid)
            el.update({votes})
        }
    }
}
</script>